export default "/images/1f48991fbac90e16f90cb593a06f6c5b.avif";